import React, {
	Component,
} from 'react';



class HeaderOptionsSwitchLayout extends Component {

	render() {
		const {
			children,
		} = this.props;

		return (
			<div className="header-options-switch-layout">
				{children}
			</div>
		);
	}

}



export default HeaderOptionsSwitchLayout;
